// src/app/redux/actions/formationsActions.js

export const FETCH_FORMATIONS_REQUEST = "FETCH_FORMATIONS_REQUEST";
export const FETCH_FORMATIONS_SUCCESS = "FETCH_FORMATIONS_SUCCESS";
export const FETCH_FORMATIONS_FAIL = "FETCH_FORMATIONS_FAIL";

export const CREATE_FORMATION_REQUEST = "CREATE_FORMATION_REQUEST";
export const CREATE_FORMATION_SUCCESS = "CREATE_FORMATION_SUCCESS";
export const CREATE_FORMATION_FAIL = "CREATE_FORMATION_FAIL";

export const UPDATE_FORMATION_REQUEST = "UPDATE_FORMATION_REQUEST";
export const UPDATE_FORMATION_SUCCESS = "UPDATE_FORMATION_SUCCESS";
export const UPDATE_FORMATION_FAIL = "UPDATE_FORMATION_FAIL";

export const DELETE_FORMATION_REQUEST = "DELETE_FORMATION_REQUEST";
export const DELETE_FORMATION_SUCCESS = "DELETE_FORMATION_SUCCESS";
export const DELETE_FORMATION_FAIL = "DELETE_FORMATION_FAIL";

// Excel
export const DOWNLOAD_FORMATIONS_TEMPLATE_REQUEST = "DOWNLOAD_FORMATIONS_TEMPLATE_REQUEST";
export const DOWNLOAD_FORMATIONS_TEMPLATE_SUCCESS = "DOWNLOAD_FORMATIONS_TEMPLATE_SUCCESS";
export const DOWNLOAD_FORMATIONS_TEMPLATE_FAIL = "DOWNLOAD_FORMATIONS_TEMPLATE_FAIL";

export const IMPORT_FORMATIONS_EXCEL_REQUEST = "IMPORT_FORMATIONS_EXCEL_REQUEST";
export const IMPORT_FORMATIONS_EXCEL_SUCCESS = "IMPORT_FORMATIONS_EXCEL_SUCCESS";
export const IMPORT_FORMATIONS_EXCEL_FAIL = "IMPORT_FORMATIONS_EXCEL_FAIL";
export const CLEAR_FORMATIONS_IMPORT_RESULT = "CLEAR_FORMATIONS_IMPORT_RESULT";

export const EXPORT_FORMATIONS_REQUEST = "EXPORT_FORMATIONS_REQUEST";
export const EXPORT_FORMATIONS_SUCCESS = "EXPORT_FORMATIONS_SUCCESS";
export const EXPORT_FORMATIONS_FAIL = "EXPORT_FORMATIONS_FAIL";

export const SET_FORMATIONS_LOADING = "SET_FORMATIONS_LOADING";
export const SET_FORMATIONS_BULK_LOADING = "SET_FORMATIONS_BULK_LOADING";
export const CLEAR_FORMATIONS_ERROR = "CLEAR_FORMATIONS_ERROR";

/* =========================
   ACTION CREATORS
========================= */

export const setFormationsLoading = (loading) => ({
    type: SET_FORMATIONS_LOADING,
    payload: loading,
});

export const setFormationsBulkLoading = (loading) => ({
    type: SET_FORMATIONS_BULK_LOADING,
    payload: loading,
});

export const clearFormationsError = () => ({
    type: CLEAR_FORMATIONS_ERROR,
});

export const clearFormationsImportResult = () => ({
    type: CLEAR_FORMATIONS_IMPORT_RESULT,
});

// CRUD
export const fetchFormationsRequest = () => ({ type: FETCH_FORMATIONS_REQUEST });
export const fetchFormationsSuccess = (data) => ({ type: FETCH_FORMATIONS_SUCCESS, payload: data });
export const fetchFormationsFail = (error) => ({ type: FETCH_FORMATIONS_FAIL, error });

export const createFormationRequest = (payload) => ({ type: CREATE_FORMATION_REQUEST, payload });
export const createFormationSuccess = (data) => ({ type: CREATE_FORMATION_SUCCESS, payload: data });
export const createFormationFail = (error) => ({ type: CREATE_FORMATION_FAIL, error });

export const updateFormationRequest = (id, payload) => ({
    type: UPDATE_FORMATION_REQUEST,
    payload: { id, payload },
});
export const updateFormationSuccess = (data) => ({ type: UPDATE_FORMATION_SUCCESS, payload: data });
export const updateFormationFail = (error) => ({ type: UPDATE_FORMATION_FAIL, error });

export const deleteFormationRequest = (id) => ({ type: DELETE_FORMATION_REQUEST, payload: { id } });
export const deleteFormationSuccess = (id) => ({ type: DELETE_FORMATION_SUCCESS, payload: { id } });
export const deleteFormationFail = (error) => ({ type: DELETE_FORMATION_FAIL, error });

export const FETCH_FORMATIONS_BY_CATALOGUE_REQUEST = "FETCH_FORMATIONS_BY_CATALOGUE_REQUEST";
export const FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS = "FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS";
export const FETCH_FORMATIONS_BY_CATALOGUE_FAIL = "FETCH_FORMATIONS_BY_CATALOGUE_FAIL";


export const fetchFormationsByCatalogueRequest = (catalogueId) => ({
    type: FETCH_FORMATIONS_BY_CATALOGUE_REQUEST,
    payload: { catalogueId },
});

export const fetchFormationsByCatalogueSuccess = (data, catalogueId) => ({
    type: FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS,
    payload: data,
    catalogueId,
});

export const fetchFormationsByCatalogueFail = (error) => ({
    type: FETCH_FORMATIONS_BY_CATALOGUE_FAIL,
    payload: error,
});


// Excel
export const downloadFormationsTemplateRequest = () => ({
    type: DOWNLOAD_FORMATIONS_TEMPLATE_REQUEST,
});

export const importFormationsExcelRequest = (file, { dryRun = true, action = "add" } = {}) => ({
    type: IMPORT_FORMATIONS_EXCEL_REQUEST,
    payload: { file, dryRun, action },
});

export const exportFormationsRequest = () => ({
    type: EXPORT_FORMATIONS_REQUEST,
});
